<template>
  <div>
    <base-dialog
      width="600px"
      :input="formModel"
      :title="'编辑处理状态: '+formModel.plateNumber"
      :dialogVisible.sync="visible"
    >
      <div class="d-flex flex-column align-center justify-center" style="margin-bottom: 10px">
        <div>当前状态：<span :style="{
          fontWeight: 'bold',
          color: formModel.dealType === 0? '#9a7d39':'#4d88ab'}">{{formModel.dealType === 0 ?'未处理':'已处理'}}</span></div>
        <div>是否标记当前状态为<span :style="{
          fontWeight: 'bold',
          color: formModel.dealType === 1? '#9a7d39':'#4d88ab'}">{{formModel.dealType === 0?'已处理':'未处理'}}</span>?</div>
      </div>
      <div class="d-flex align-center justify-center">

      </div>
      <div slot="footer">
        <el-button   type="primary" size="small" @click="handle(formModel.dealType === 0)"><i
          class="el-icon-circle-check button-icon"></i>确认
        </el-button>
        <el-button type="primary" size="small" @click="cancel()"><i
          class="el-icon-circle-close button-icon"></i>取消
        </el-button>
      </div>
    </base-dialog>
  </div>
</template>
<style scoped lang="scss">
  .button-icon {
    margin-right: 10px;
  }
</style>

<!--☯js-->
<script>
  import * as eventJs from '../../../../../../src/business-components/update-deal-status/event.js'
  const {event, life, watch} = eventJs.default ? eventJs.default : eventJs
  import * as modelJS from '../../../../../../src/business-components/update-deal-status/model.js'
  const model = modelJS.default ? modelJS.default : modelJS
  import * as methodsJs from '../../../../../../src/business-components/update-deal-status/methods.js'
  const methodsSource = methodsJs.default ? methodsJs.default : methodsJs
  import vmConfig from '../../../../core/vmConfigHandler.js'
  // 异步加载某些情况下会出问题，原因未知，所以暂时不采用异步加载
  // r => require.ensure([], () => r(require('%path')), 'c-business-update-deal-status')
  export default {
    name: 'business-update-deal-status', // o not use built-in or reserved HTML elements as component id:img, 意思是不能和html标签同名，那么加个下划线好了
    components: {
      /*import components file template:'business-update-deal-status': require('%path').default,
       */
      /*start:import components file*/
'base-account-info': require('./../../base-components/account-info/index.vue').default,
       'base-back': require('./../../base-components/back/index.vue').default,
       'base-blackHandle': require('./../../base-components/blackHandle/index.vue').default,
       'base-bottomFloat': require('./../../base-components/bottomFloat/index.vue').default,
       'base-card-header': require('./../../base-components/card-header/index.vue').default,
       'base-carDriverInfo': require('./../../base-components/carDriverInfo/index.vue').default,
       'base-cascader-select-on-click': require('./../../base-components/cascader-select-on-click/index.vue').default,
       'base-check-all': require('./../../base-components/check-all/index.vue').default,
       'base-cropper': require('./../../base-components/cropper/index.vue').default,
       'base-datetimerange': require('./../../base-components/datetimerange/index.vue').default,
       'base-dialog': require('./../../base-components/dialog/index.vue').default,
       'base-empty': require('./../../base-components/empty/index.vue').default,
       'base-export': require('./../../base-components/export/index.vue').default,
       'base-filter': require('./../../base-components/filter/index.vue').default,
       'base-image-carousel': require('./../../base-components/image-carousel/index.vue').default,
       'base-img-base': require('./../../base-components/img-base/index.vue').default,
       'base-img-viewer': require('./../../base-components/img-viewer/index.vue').default,
       'base-key-value': require('./../../base-components/key-value/index.vue').default,
       'base-my-column': require('./../../base-components/my-column/index.vue').default,
       'base-number-input': require('./../../base-components/number-input/index.vue').default,
       'base-plate': require('./../../base-components/plate/index.vue').default,
       'base-quarter-datepicker': require('./../../base-components/quarter-datepicker/index.vue').default,
       'base-simple-menu': require('./../../base-components/simple-menu/index.vue').default,
       'base-yearrange': require('./../../base-components/yearrange/index.vue').default,
       /*end:import components file*/
    },
    ...vmConfig(model, life, event, watch, methodsSource)
  }
</script>